import React, { useContext, useEffect } from "react";
import { webcamInstance } from "../Artist/js/Lotus-Webcam";
import { createLotusLedByLight } from "../Artist/js/Lotus-LedByLight";
import { CameraContext } from "@providers/CameraProvider";
import { useLoaderDone } from "../hooks/useLoaderDone";
import {
  LotusWebcamWrapper,
  LotusContainer,
} from "../styles/components/Global/Artwork";

const LotusWebcam = () => {
  const { cameraAllowed } = useContext(CameraContext);
  const loaderDone = useLoaderDone();

  useEffect(() => {
    if (cameraAllowed !== true || !loaderDone) return;
    import("p5").then(p5 => {
      const webcamSketch = new p5.default(p => webcamInstance(p));
      new p5.default(
        p => createLotusLedByLight(p, webcamSketch),
        "lotus_ledbylight"
      );
    });
  }, [cameraAllowed, loaderDone]);

  return (
    <LotusWebcamWrapper
      style={cameraAllowed === false ? { display: "none" } : undefined}
    >
      <LotusContainer>
        <div id="lotus_ledbylight"></div>
      </LotusContainer>
    </LotusWebcamWrapper>
  );
};

export default LotusWebcam;
